import React from "react";

export default function ChangePassword() {
  return (
    <div className="content">
      {/* Page Header */}
      <div className="mb-3 border-bottom pb-3">
        <h4 className="fw-bold mb-0">Settings</h4>
      </div>
      {/* End Page Header */}

      <div className="card">
        <div className="card-body">
          <div className="row">
            {/* Main Content */}
            <div className="col-lg-12">
              <div className="border-1 border-start ps-4">
                <h5 className="fw-bold pb-3 mb-4 border-1 border-bottom">
                  Change Password
                </h5>

                {/* Inputs Row */}
                <div className="row border-bottom mb-3">
                  {/* New Password */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-5">
                        <label className="form-label mb-0">
                          New Password <span className="text-danger">*</span>
                        </label>
                      </div>

                      <div className="col-lg-7">
                        <div className="position-relative">
                          <div className="pass-group input-group position-relative border rounded">
                            <span className="input-group-text bg-white border-0">
                              <i className="ti ti-lock text-dark fs-14"></i>
                            </span>

                            <input
                              type="password"
                              className="pass-inputb form-control ps-0 border-0"
                              placeholder="****************"
                            />

                            <span className="input-group-text bg-white border-0">
                              <i className="ti toggle-passwordb ti-eye-off text-dark fs-14"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="col-lg-6">
                    <div className="row align-items-center mb-3">
                      <div className="col-lg-5">
                        <label className="form-label mb-0">
                          Confirm Password{" "}
                          <span className="text-danger">*</span>
                        </label>
                      </div>

                      <div className="col-lg-7">
                        <div className="position-relative">
                          <div className="pass-group input-group position-relative border rounded">
                            <span className="input-group-text bg-white border-0">
                              <i className="ti ti-lock text-dark fs-14"></i>
                            </span>

                            <input
                              type="password"
                              className="pass-inputa form-control ps-0 border-0"
                              placeholder="****************"
                            />

                            <span className="input-group-text bg-white border-0">
                              <i className="ti toggle-passworda ti-eye-off text-dark fs-14"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="d-flex justify-content-end align-items-center gap-2">
                  <button className="btn btn-light btn-md fs-13 fw-medium rounded">
                    Cancel
                  </button>
                  <button className="btn btn-primary btn-md fs-13 fw-medium rounded">
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
